import CapturePreview, { injectPlaceholder } from 'gleam-shared/embeds/CapturePreview'

const URL_ATTR = 'data-lazy-capture-preview'

export const SELECTOR = `[${URL_ATTR}]`
export const NEEDS_PLACEHOLDER = false
export const AWAITS_USER_ACTION = false

export default function loadCapturePreview(parent, injectsPlaceholder = false) {
  if (injectsPlaceholder) {
    injectPlaceholder(parent)
    return
  }

  const url = parent.getAttribute(URL_ATTR)

  return CapturePreview(parent, url)
}
